import { CALL_API } from '../../../middleware/api';
export const GET_HELP_CATEGORY_ARTICLES_REQUEST = 'GET_HELP_CATEGORY_ARTICLES_REQUEST';
export const GET_HELP_CATEGORY_ARTICLES_SUCCESS = 'GET_HELP_CATEGORY_ARTICLES_SUCCESS';
export const GET_HELP_CATEGORY_ARTICLES_FAILURE = 'GET_HELP_CATEGORY_ARTICLES_FAILURE';
export const GET_HELP_ARTICLES_REQUEST = 'GET_HELP_ARTICLES_REQUEST';
export const GET_HELP_ARTICLES_SUCCESS = 'GET_HELP_ARTICLES_SUCCESS';
export const GET_HELP_ARTICLES_FAILURE = 'GET_HELP_ARTICLES_FAILURE';
export const getHelpCategoryArticles = ({ locale, filter_category_id, }) => {
    const params = new URLSearchParams();
    params.set('filter_category_id', filter_category_id);
    params.set('locale', locale);
    params.set('order_visits', '1');
    params.set('filter_status_published', '1');
    params.set('filter_status_draft', '0');
    params.set('filter_visibility_visible', '1');
    params.set('filter_visibility_hidden', '0');
    return {
        [CALL_API]: {
            endpoint: `/help/articles?${params}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            extra: {
                categoryId: filter_category_id,
            },
            types: [
                GET_HELP_CATEGORY_ARTICLES_REQUEST,
                GET_HELP_CATEGORY_ARTICLES_SUCCESS,
                GET_HELP_CATEGORY_ARTICLES_FAILURE,
            ],
        },
    };
};
export const getHelpArticlesCall = ({ locale, search_title, }) => {
    const params = new URLSearchParams();
    if (search_title)
        params.set('search_title', search_title);
    params.set('locale', locale);
    params.set('order_visits', '1');
    params.set('filter_status_published', '1');
    params.set('filter_status_draft', '0');
    params.set('filter_visibility_visible', '1');
    params.set('filter_visibility_hidden', '0');
    return {
        [CALL_API]: {
            endpoint: `/help/articles?${params}`,
            method: 'GET',
            headers: { Accept: 'application/json' },
            types: [
                GET_HELP_ARTICLES_REQUEST,
                GET_HELP_ARTICLES_SUCCESS,
                GET_HELP_ARTICLES_FAILURE,
            ],
        },
    };
};
